// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class HttpError extends Error {
    status;
    body;
    constructor(error, data) {
        const requestInfo = sanitizeAxiosConfig(error.config ?? {});
        const responseInfo = error.response;
        const errorMessage = `[HTTP ERROR]: An error occurred while calling ${requestInfo.method} ${requestInfo.url}.
    Request Headers: ${JSON.stringify(requestInfo.headers)}
    Request Payload: ${JSON.stringify(requestInfo.data)}
    Response Status: ${responseInfo?.status}
    Response Headers: ${JSON.stringify(responseInfo?.headers)}
    Response Data: ${JSON.stringify(data)}`;
        super(errorMessage);
        this.status = error.response?.status;
        this.body = data;
    }
}
function sanitizeAxiosConfig(info) {
    return {
        ...info,
        ...(info.headers && {
            headers: {
                ...info.headers,
                ...(info.headers.Authorization && { Authorization: '<hidden>' }),
            },
        }),
    };
}
